import axios from 'axios';
import React, { useContext, useEffect } from 'react';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { AuthProvider } from '../Context/AuthContext';
import DasboardSidebar from '../Dashboard/DasboardHome/DasboardSidebar';
import DashboardHome from '../Dashboard/DasboardHome/DashboardHome';
import DashboardNavbar from '../Dashboard/DasboardHome/DashboardNavbar';
import Sidebar from '../Dashboard/DasboardHome/Sidebar';
import ScrollToTop from '../Shared/ScrollToTop/ScrollToTop';

const DashboardLayout = () => {
    const { user } = useContext(AuthProvider)
    const [admindata, setAdminData] = useState("")


    return (
        <div>
            {
                // admindata?.role === "admin" ?
                <>
                    <ScrollToTop />
                    {/* <DashboardNavbar /> */}
                    <div className='md:flex relative min-h-screen'>
                        <Sidebar />
                        <div className='flex-1 md:ml-64'>
                            <div className='bg-indigo-300 py-7 w-full'></div>
                            <div className='p-5'>
                                <Outlet />
                            </div>
                        </div>
                    </div>
                </>
                // :
                // <div className='min-h-screen flex items-center justify-center  '>
                //    <h3 className='text-xl text-center text-red-500 md:text-3xl'>You are not eligible to access this section</h3>
                // </div>
            }
        </div>
    );
};

export default DashboardLayout;